import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, unref as _unref } from "vue";
const _hoisted_1 = {
  class: "flex items-center"
};
import { Division, LeagueCompetition } from "@/modules/competitions/entity";
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import Flag from "@/modules/vue/components/Flag.vue";
import Submenu from "./Submenu";
import MatchdayComponent from "@/modules/competitions/components/Matchday.vue";
import { onBeforeRouteLeave } from "vue-router";
import ItemsPaginator from "@/modules/vue/components/ItemsPaginator.vue";
import ActionButton from "./ActionButton.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Matches',
  async setup(__props) {
    let __temp, __restore;
    const route = useRoute();
    const division = ref();
    const startPage = ref();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      division.value = await Division.createQueryBuilder('division').innerJoinAndSelect('division.competition', 'competition').innerJoinAndSelect('competition.country', 'country').innerJoinAndSelect('competition.divisions', 'competitionDivision').innerJoinAndSelect('division.matchdays', 'matchday').innerJoinAndSelect('matchday.division', 'division2').innerJoinAndSelect('matchday.season', 'season').leftJoinAndSelect('matchday.matches', 'match').innerJoinAndSelect('match.homeTeam', 'homeTeam').innerJoinAndSelect('match.awayTeam', 'awayTeam').where('season.current = true').andWhere('division.id = :divisionId', {
        divisionId: route.params.id
      }).getOneOrFail();
      startPage.value = Math.max(division.value.matchdays.indexOf(m => m.current) + 1, 1);
    })), __temp = await __temp, __restore(), __temp);
    const hasTable = computed(() => division.value.competition instanceof LeagueCompetition);
    onBeforeRouteLeave(watch(() => route.params, refresh));
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        back: ""
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_1, [division.value.competition.country ? (_openBlock(), _createBlock(Flag, {
          key: 0,
          country: division.value.competition.country,
          class: "mr-2"
        }, null, 8, ["country"])) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(division.value.name), 1)])]),
        submenu: _withCtx(() => [_createVNode(_unref(Submenu), {
          "has-table": _unref(hasTable)
        }, null, 8, ["has-table"])]),
        actionButton: _withCtx(() => [_createVNode(ActionButton, {
          division: division.value,
          divisions: division.value.competition.divisions
        }, null, 8, ["division", "divisions"])]),
        default: _withCtx(() => [_createVNode(ItemsPaginator, {
          "all-items": _ctx.collect(division.value.matchdays).sortBy('id').toArray(),
          "per-page": 1,
          "start-page": startPage.value,
          class: "mt-2"
        }, {
          default: _withCtx(({
            items
          }) => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, matchday => {
            return _openBlock(), _createElementBlock("div", {
              key: matchday.id,
              class: "mb-2"
            }, [_createVNode(MatchdayComponent, {
              matchday: matchday
            }, null, 8, ["matchday"])]);
          }), 128))]),
          _: 1
        }, 8, ["all-items", "start-page"])]),
        _: 1
      });
    };
  }
});